import { Link } from "react-router-dom";
import { useSeo } from "../../hooks/useSeo";
import { faqs } from "../../mocks/chigua";
import FAQAccordion from "../../components/feature/FAQAccordion";

export default function Faq() {
  useSeo({
    title: "常见问题 FAQ｜吃瓜爆料真假怎么判断 - 今天吃瓜",
    description:
      "关于「今天吃瓜」吃瓜爆料的常见问题：爆料是否真实可信、内容侵权如何反馈、如何投稿报料、内容多久更新一次等，为你一一解答。",
    keywords: "吃瓜常见问题,吃瓜爆料真假,投稿报料,今天吃瓜FAQ",
    path: "/faq",
    schemas: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://fish3.cn/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "https://fish3.cn/faq" },
        ],
      },
    ],
  });

  return (
    <div className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
      <nav className="flex items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑">
        <Link to="/" className="hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
        <span className="text-foreground-800">常见问题</span>
      </nav>

      <header className="mt-5 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
          <i className="ri-question-answer-line" aria-hidden="true" />
          FAQ · 常见问题
        </span>
        <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">吃瓜之前，先看看这里</h1>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
          关于「今天吃瓜」的爆料来源、内容真假、权益反馈、投稿方式等问题，我们整理了一份贴心问答，希望能帮你把瓜吃得更明白、更安心。
        </p>
      </header>

      <div className="mt-10">
        <FAQAccordion />
      </div>

      <div className="mt-10 flex flex-col items-center gap-3 rounded-2xl border border-background-200 bg-background-100/70 p-8 text-center">
        <i className="ri-service-line text-3xl text-primary-500" aria-hidden="true" />
        <h2 className="font-heading text-xl font-bold text-foreground-950">还有别的疑问？</h2>
        <p className="max-w-xl text-sm leading-relaxed text-foreground-600">如果上面的回答没能解决你的问题，可以直接到「联系我们」页面给我们留言，我们会在核实后尽快回复。</p>
        <Link to="/contact" className="mt-2 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600">
          联系今天吃瓜
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}